module.exports = __webpack_public_path__ + "img/XTZ.4039e2d5.svg";